<template>
    <div class="category-content">
        <div class="category-content-images">
            <p class="uploaded-image-title">Uploaded Images</p>

            <div class="category-content-images-container">
                <div v-for="(img, idx) in template.images"
                     :key="idx"
                     class="position-relative">
                    <span class="position-absolute maximize-img"
                          @click="maximizeImageHandler($event, img.path)">
                         <font-awesome-icon :icon="['fas', 'eye']" size="sm"/>
                    </span>
                    <img width="148" height="83" :src="s3pathThumb +  img.path" alt="">
                </div>
            </div>
        </div>
                <div class="category-content-categories">
                    <div>
                        <div class="category-container my-4"
                             v-for="(category, catIdx) in template.category"
                             :key="catIdx">

                            <div class="d-flex justify-content-between">
                                <div class="show-slide">
                                    <p class="category-name">{{category.name}}</p>

                                    <div class="d-flex justify-content-between">
                                        <div class="category-slides-container">
                                            <div class="position-relative"
                                                 v-for="(img, imgIdx) in category.slide_categories"
                                                 :key="imgIdx">
                                                <img class="slide-img" :id='"img-"+catIdx+"-"+imgIdx' width="147"
                                                     height="83"
                                                     :src="img.path === 'defultSlide.svg'  ? require(`../../../../assets/images/defultSlide.svg`):s3pathThumb +  img.path"
                                                     alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    </div>

    <ShowImageModal v-if="showImgModal" :imagePath="imagePath" @close-modal="showImgModal = false"/>
</template>


<script>

    import {defineAsyncComponent} from "vue";

    const ShowImageModal = defineAsyncComponent(() =>
        import ('../../../components/ShowImageModal')
    );

    export default {
        name: 'slides-component',
        components: {ShowImageModal},
        data() {
            return {
                s3pathThumb: "https://dk703uarlyapi.cloudfront.net/thumbnail/",
                s3pathImage: "https://dk703uarlyapi.cloudfront.net/images",
                showImgModal: false,
                imagePath: ''
            }
        },
        async mounted() {
            if (process.env.VUE_ENV === 'development')
            console.log("answers.slides ", this.template.slides)
        },
        props: ['template'],
        methods: {
            maximizeImageHandler(e, path) {

                this.imagePath = this.s3pathImage + '/' + path;
                this.showImgModal = true;

            },

        }
    }
</script>

<style scoped>
    .uploaded-image-title {
        font-family: Poppins, sans-serif;
        font-size: 17px
    }

    .category-content {
        display: flex;
        height: 589px;
        border-radius: 11px;
        padding: 27.8px 15px 27.8px 24px;
    }

    .category-content-images {
        border-right: 1px solid #e65c00;
        width: 200px;
    }

    .category-content-images-container {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 180px;
        height: 500px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .category-content-categories {
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 16px;
        padding-left: 25px;
        width: 100%;
    }

    .category-slides-container {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        width: 100%;
        max-height: 200px;
        min-height: 10px;
        overflow-y: auto
    }

    .category-name {
        font-family: Poppins, sans-serif;
        font-size: 17px;
        margin-bottom: 10px;
    }

    .add-slide {
        width: 5%;
    }

    .show-slide {
        width: 95%;
    }

    .slide-img {
        margin: 9px 3px 0 0;
        border-radius: 12px;
    }

    .category-container {
        position: relative;
        border: 1px solid #39525C;
        padding: 12px;
        border-radius: 6px;
    }

    .maximize-img {
        right: 35px;
        top: 3px;
        color: #f8f9fa;
        background-color: #0000004d;
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
</style>